import React from "react";
import MuiCircularProgress from "@mui/material/CircularProgress";
import MuiButton from "@mui/material/Button";
import MuiSearchIcon from "@mui/icons-material/Search";
import MuiDeleteIcon from "@mui/icons-material/Delete";
import MuiTextField from "@mui/material/TextField";
import MuiFolderOpenIcon from "@mui/icons-material/FolderOpen";
import MuiAutocomplete from "@mui/material/Autocomplete";

// Source
import * as HelperSrc from "../../HelperSrc";
import * as ModelHelperSrc from "../../model/HelperSrc";
import * as ModelDocument from "../../model/custom/Document";
import ControllerDocumentList from "../../controller/custom/DocumentList";
import ControllerLocalization from "../../controller/Localization";
import ViewLoader from "../Loader";
import ViewPagination from "../../view/Pagination";
import ViewDialog from "../../view/Dialog";

let isRendered = false;

const viewPageDocumentList: React.FC<ModelDocument.Iprops> = (props) => {
    // Variable
    const controllerDocumentList = new ControllerDocumentList(isRendered);
    const controllerLocalization = new ControllerLocalization(isRendered);

    // Method
    controllerDocumentList.initializeHook();
    controllerLocalization.initializeHook();

    // Render
    isRendered = true;

    const documentListAutocompleteSlotProps = HelperSrc.createAutocompleteSlotProps("view_list_popper", [0, 0]);

    if (
        controllerLocalization.getStorageMain &&
        controllerDocumentList.getSelectOption &&
        controllerDocumentList.getPagination &&
        controllerDocumentList.getFilter &&
        controllerDocumentList.getDataMainList
    ) {
        return (
            <div className="view_document_list" data-at_id="view_document_list">
                <div>
                    {(() => {
                        const html: JSX.Element[] = [];

                        if (
                            controllerDocumentList.getStorageDocumentPreview &&
                            Object.entries(controllerDocumentList.getStorageDocumentPreview).length !== 0
                        ) {
                            html.push(
                                <div>
                                    <div className="description">{controllerLocalization.getStorageMain.save_data_list}</div>
                                    <table className="save_list">
                                        <colgroup>
                                            <col className="cell id" />
                                            <col className="cell project_name" />
                                            <col className="cell client_name" />
                                            <col className="cell client_industry" />
                                            <col className="cell filename" />
                                            <col className="cell reporting_year" />
                                            <col className="cell template_language" />
                                            <col className="cell" />
                                        </colgroup>
                                        <thead className="filter">
                                            <tr className="row not_hover">
                                                <th className="cell field_container">{controllerLocalization.getStorageMain.id}</th>
                                                <th className="cell field_container">{controllerLocalization.getStorageMain.project_name}</th>
                                                <th className="cell field_container">{controllerLocalization.getStorageMain.client_name}</th>
                                                <th className="cell field_container">{controllerLocalization.getStorageMain.client_industry}</th>
                                                <th className="cell field_container">{controllerLocalization.getStorageMain.filename}</th>
                                                <th className="cell field_container">{controllerLocalization.getStorageMain.reporting_year}</th>
                                                <th className="cell field_container">{controllerLocalization.getStorageMain.template_language}</th>
                                                <th className="cell field_container"></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr
                                                className="row"
                                                data-at_id="tr_list_data_draft"
                                                onClick={() => {
                                                    controllerDocumentList.clickDraftItem();
                                                }}
                                            >
                                                <td className="cell">{controllerDocumentList.getStorageDocumentPreview.id}</td>
                                                <td className="cell">{controllerDocumentList.getStorageDocumentPreview.project_name}</td>
                                                <td className="cell">{controllerDocumentList.getStorageDocumentPreview.client_name}</td>
                                                <td className="cell">
                                                    {(() => {
                                                        return HelperSrc.showSelectedOptionName(
                                                            controllerDocumentList.getSelectOption.client_industry,
                                                            controllerDocumentList.getStorageDocumentPreview.client_industry
                                                        );
                                                    })()}
                                                </td>
                                                <td className="cell">{controllerDocumentList.getStorageDocumentPreview.input_file_name}</td>
                                                <td className="cell">{controllerDocumentList.getStorageDocumentPreview.reporting_year}</td>
                                                <td className="cell">{controllerDocumentList.getStorageDocumentPreview.template_language}</td>
                                                <td className="cell">
                                                    {(() => {
                                                        const html: JSX.Element[] = [];

                                                        if (
                                                            HelperSrc.checkRole(
                                                                controllerDocumentList.getStorageRole,
                                                                ["superuser", "manager"],
                                                                props.userData
                                                            )
                                                        ) {
                                                            html.push(
                                                                <MuiDeleteIcon
                                                                    data-at_id="icon_delete_draft"
                                                                    className="button_icon"
                                                                    onClick={(event) => {
                                                                        controllerDocumentList.clickDraftRemove(event);
                                                                    }}
                                                                />
                                                            );
                                                        }

                                                        return html;
                                                    })()}
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            );
                        }

                        return html;
                    })()}
                    <div className="button_container">
                        <MuiButton
                            className="button_primary"
                            data-at_id="button_goto_create"
                            disabled={controllerDocumentList.getApiLoadingList.selectOption}
                            onClick={() => {
                                controllerDocumentList.clickCreate();
                            }}
                        >
                            {controllerLocalization.getStorageMain.create}
                        </MuiButton>
                    </div>
                    <table>
                        {(() => {
                            const html: JSX.Element[] = [];

                            html.push(
                                <>
                                    <colgroup>
                                        <col className="cell id" />
                                        <col className="cell project_name" />
                                        <col className="cell client_name" />
                                        <col className="cell client_industry" />
                                        <col className="cell filename" />
                                        <col className="cell reporting_year" />
                                        <col className="cell template_language" />
                                        <col className="cell update_date" />
                                        <col className="cell update_by" />
                                        <col className="cell" />
                                    </colgroup>
                                    <thead className="filter">
                                        <tr className="row filter_action">
                                            <td>
                                                <MuiButton
                                                    className="button_primary container_button"
                                                    data-at_id="button_apply"
                                                    disabled={controllerDocumentList.getApiLoadingList.selectOption}
                                                    onClick={() => {
                                                        controllerDocumentList.clickFilterApply();
                                                    }}
                                                >
                                                    {(() => {
                                                        const html: JSX.Element[] = [];

                                                        if (controllerDocumentList.getApiLoadingList.selectOption) {
                                                            html.push(<MuiCircularProgress className="icon_progress" />);
                                                        } else {
                                                            html.push(
                                                                <span className="button_label">
                                                                    {controllerLocalization.getStorageMain.apply} <MuiSearchIcon />
                                                                </span>
                                                            );
                                                        }

                                                        return html;
                                                    })()}
                                                </MuiButton>
                                            </td>
                                        </tr>
                                        <tr className="row not_hover">
                                            <th className="cell field_container">{controllerLocalization.getStorageMain.id}</th>
                                            <th className="cell field_container">
                                                <MuiAutocomplete
                                                    slotProps={documentListAutocompleteSlotProps}
                                                    blurOnSelect
                                                    options={(() => {
                                                        const optionList: ModelHelperSrc.IelementOption[] = [{ value: "", display_name: "" }];

                                                        for (const optionData of Object.values(controllerDocumentList.getSelectOption.project_name)) {
                                                            const optionDataTyped = optionData as ModelHelperSrc.IelementOption;

                                                            optionList.push(optionDataTyped);
                                                        }

                                                        return optionList;
                                                    })()}
                                                    getOptionLabel={(option) => option.display_name}
                                                    renderOption={(props, option) => {
                                                        if (controllerLocalization.getStorageMain) {
                                                            return (
                                                                <li {...props}>
                                                                    {option.display_name || controllerLocalization.getStorageMain.select}
                                                                </li>
                                                            );
                                                        }
                                                    }}
                                                    isOptionEqualToValue={(opt, val) => String(opt.value) === String(val.value)}
                                                    renderInput={(params) => (
                                                        <MuiTextField
                                                            {...params}
                                                            variant="outlined"
                                                            className="field_value"
                                                            name="project_name"
                                                            label={
                                                                controllerLocalization.getStorageMain
                                                                    ? controllerLocalization.getStorageMain.project_name
                                                                    : ""
                                                            }
                                                        />
                                                    )}
                                                />
                                            </th>
                                            <th data-at_id="th_client_name" className="cell field_container">
                                                <MuiAutocomplete
                                                    slotProps={documentListAutocompleteSlotProps}
                                                    blurOnSelect
                                                    options={(() => {
                                                        const optionList: ModelHelperSrc.IelementOption[] = [{ value: "", display_name: "" }];

                                                        for (const optionData of Object.values(controllerDocumentList.getSelectOption.client_name)) {
                                                            const optionDataTyped = optionData as ModelHelperSrc.IelementOption;

                                                            optionList.push(optionDataTyped);
                                                        }

                                                        return optionList;
                                                    })()}
                                                    getOptionLabel={(option) => option.display_name}
                                                    renderOption={(props, option) => {
                                                        if (controllerLocalization.getStorageMain) {
                                                            return (
                                                                <li
                                                                    {...props}
                                                                    data-at_id={`select_client_name_${option.value ? option.value : "select"}`}
                                                                >
                                                                    {option.display_name || controllerLocalization.getStorageMain.select}
                                                                </li>
                                                            );
                                                        }
                                                    }}
                                                    isOptionEqualToValue={(opt, val) => String(opt.value) === String(val.value)}
                                                    renderInput={(params) => (
                                                        <MuiTextField
                                                            {...params}
                                                            variant="outlined"
                                                            className="field_value"
                                                            name="client_name"
                                                            data-at_id="input_client_name"
                                                            label={
                                                                controllerLocalization.getStorageMain
                                                                    ? controllerLocalization.getStorageMain.client_name
                                                                    : ""
                                                            }
                                                        />
                                                    )}
                                                />
                                            </th>
                                            <th data-at_id="th_client_industry" className="cell field_container">
                                                <MuiAutocomplete
                                                    slotProps={documentListAutocompleteSlotProps}
                                                    blurOnSelect
                                                    options={(() => {
                                                        const optionList: ModelHelperSrc.IelementOption[] = [{ value: "", display_name: "" }];

                                                        for (const optionData of Object.values(
                                                            controllerDocumentList.getSelectOption.client_industry
                                                        )) {
                                                            const optionDataTyped = optionData as ModelHelperSrc.IelementOption;

                                                            optionList.push(optionDataTyped);
                                                        }

                                                        return optionList;
                                                    })()}
                                                    getOptionLabel={(option) => option.display_name}
                                                    renderOption={(props, option) => {
                                                        if (controllerLocalization.getStorageMain) {
                                                            return (
                                                                <li
                                                                    {...props}
                                                                    data-at_id={`select_client_industry_${option.value ? option.value : "select"}`}
                                                                >
                                                                    {option.display_name || controllerLocalization.getStorageMain.select}
                                                                </li>
                                                            );
                                                        }
                                                    }}
                                                    isOptionEqualToValue={(opt, val) => String(opt.value) === String(val.value)}
                                                    renderInput={(params) => (
                                                        <div>
                                                            <MuiTextField
                                                                {...params}
                                                                variant="outlined"
                                                                className="field_value"
                                                                label={
                                                                    controllerLocalization.getStorageMain
                                                                        ? controllerLocalization.getStorageMain.client_industry
                                                                        : ""
                                                                }
                                                            />
                                                            <input
                                                                type="hidden"
                                                                className="field_value"
                                                                name="client_industry"
                                                                defaultValue={controllerDocumentList.getElementClientIndustryValue}
                                                            />
                                                        </div>
                                                    )}
                                                    onChange={(_, option) => {
                                                        if (option && controllerDocumentList.setElementClientIndustryValue) {
                                                            controllerDocumentList.setElementClientIndustryValue(option.value as string);
                                                        }
                                                    }}
                                                />
                                            </th>
                                            <th className="cell field_container">{controllerLocalization.getStorageMain.filename}</th>
                                            <th className="cell field_container">
                                                <MuiAutocomplete
                                                    slotProps={documentListAutocompleteSlotProps}
                                                    blurOnSelect
                                                    options={(() => {
                                                        const optionList: ModelHelperSrc.IelementOption[] = [{ value: "", display_name: "" }];

                                                        for (const optionData of Object.values(
                                                            controllerDocumentList.getSelectOption.reporting_year
                                                        )) {
                                                            const optionDataTyped = optionData as ModelHelperSrc.IelementOption;

                                                            optionList.push(optionDataTyped);
                                                        }

                                                        return optionList;
                                                    })()}
                                                    getOptionLabel={(option) => option.display_name}
                                                    renderOption={(props, option) => {
                                                        if (controllerLocalization.getStorageMain) {
                                                            return (
                                                                <li {...props}>
                                                                    {option.display_name || controllerLocalization.getStorageMain.select}
                                                                </li>
                                                            );
                                                        }
                                                    }}
                                                    isOptionEqualToValue={(opt, val) => String(opt.value) === String(val.value)}
                                                    renderInput={(params) => (
                                                        <MuiTextField
                                                            {...params}
                                                            variant="outlined"
                                                            className="field_value"
                                                            name="reporting_year"
                                                            label={
                                                                controllerLocalization.getStorageMain
                                                                    ? controllerLocalization.getStorageMain.reporting_year
                                                                    : ""
                                                            }
                                                        />
                                                    )}
                                                />
                                            </th>
                                            <th className="cell field_container">
                                                <MuiAutocomplete
                                                    slotProps={documentListAutocompleteSlotProps}
                                                    blurOnSelect
                                                    options={(() => {
                                                        const optionList: ModelHelperSrc.IelementOption[] = [{ value: "", display_name: "" }];

                                                        for (const optionData of Object.values(
                                                            controllerDocumentList.getSelectOption.template_language
                                                        )) {
                                                            const optionDataTyped = optionData as ModelHelperSrc.IelementOption;

                                                            optionList.push(optionDataTyped);
                                                        }

                                                        return optionList;
                                                    })()}
                                                    getOptionLabel={(option) => option.display_name}
                                                    renderOption={(props, option) => {
                                                        if (controllerLocalization.getStorageMain) {
                                                            return (
                                                                <li {...props}>
                                                                    {option.display_name || controllerLocalization.getStorageMain.select}
                                                                </li>
                                                            );
                                                        }
                                                    }}
                                                    isOptionEqualToValue={(opt, val) => String(opt.value) === String(val.value)}
                                                    renderInput={(params) => (
                                                        <MuiTextField
                                                            {...params}
                                                            variant="outlined"
                                                            className="field_value"
                                                            name="template_language"
                                                            label={
                                                                controllerLocalization.getStorageMain
                                                                    ? controllerLocalization.getStorageMain.template_language
                                                                    : ""
                                                            }
                                                        />
                                                    )}
                                                />
                                            </th>
                                            <th className="cell field_container">
                                                <MuiAutocomplete
                                                    slotProps={documentListAutocompleteSlotProps}
                                                    blurOnSelect
                                                    options={(() => {
                                                        const optionList: ModelHelperSrc.IelementOption[] = [{ value: "", display_name: "" }];

                                                        for (const optionData of Object.values(
                                                            controllerDocumentList.getSelectOption.latest_update
                                                        )) {
                                                            const optionDataTyped = optionData as ModelHelperSrc.IelementOption;

                                                            optionList.push(optionDataTyped);
                                                        }

                                                        return optionList;
                                                    })()}
                                                    getOptionLabel={(option) => option.display_name}
                                                    renderOption={(props, option) => {
                                                        if (controllerLocalization.getStorageMain) {
                                                            return (
                                                                <li {...props}>
                                                                    {option.display_name
                                                                        ? HelperSrc.localeFormat(new Date(option.display_name))
                                                                        : controllerLocalization.getStorageMain.select}
                                                                </li>
                                                            );
                                                        }
                                                    }}
                                                    isOptionEqualToValue={(opt, val) => String(opt.value) === String(val.value)}
                                                    renderInput={(params) => (
                                                        <MuiTextField
                                                            {...params}
                                                            variant="outlined"
                                                            className="field_value"
                                                            name="latest_update"
                                                            label={
                                                                controllerLocalization.getStorageMain
                                                                    ? controllerLocalization.getStorageMain.latest_update
                                                                    : ""
                                                            }
                                                        />
                                                    )}
                                                />
                                            </th>
                                            <th className="cell field_container">
                                                <MuiAutocomplete
                                                    slotProps={documentListAutocompleteSlotProps}
                                                    blurOnSelect
                                                    options={(() => {
                                                        const optionList: ModelHelperSrc.IelementOption[] = [{ value: "", display_name: "" }];

                                                        for (const optionData of Object.values(
                                                            controllerDocumentList.getSelectOption.latest_update_by_id
                                                        )) {
                                                            const optionDataTyped = optionData as ModelHelperSrc.IelementOption;

                                                            optionList.push(optionDataTyped);
                                                        }

                                                        return optionList;
                                                    })()}
                                                    getOptionLabel={(option) => option.display_name}
                                                    renderOption={(props, option) => {
                                                        if (controllerLocalization.getStorageMain) {
                                                            return (
                                                                <li {...props}>
                                                                    {option.display_name || controllerLocalization.getStorageMain.select}
                                                                </li>
                                                            );
                                                        }
                                                    }}
                                                    isOptionEqualToValue={(opt, val) => String(opt.value) === String(val.value)}
                                                    renderInput={(params) => (
                                                        <div>
                                                            <MuiTextField
                                                                {...params}
                                                                variant="outlined"
                                                                className="field_value"
                                                                label={
                                                                    controllerLocalization.getStorageMain
                                                                        ? controllerLocalization.getStorageMain.latest_update_by
                                                                        : ""
                                                                }
                                                            />
                                                            <input
                                                                type="hidden"
                                                                className="field_value"
                                                                name="latest_update_by_id"
                                                                defaultValue={controllerDocumentList.getElementLatestUpdateByIdValue}
                                                            />
                                                        </div>
                                                    )}
                                                    onChange={(_, option) => {
                                                        if (option && controllerDocumentList.setElementLatestUpdateByIdValue) {
                                                            controllerDocumentList.setElementLatestUpdateByIdValue(option.value as string);
                                                        }
                                                    }}
                                                />
                                            </th>
                                            <th className="cell field_container"></th>
                                        </tr>
                                    </thead>
                                </>
                            );
                            return html;
                        })()}
                        <tbody className="document_list_table" data-at_id="tbody_document_list">
                            {(() => {
                                const html: JSX.Element[] = [];

                                if (controllerDocumentList.getApiLoadingList.dataList) {
                                    html.push(
                                        <tr className="row_empty">
                                            <td>
                                                <MuiCircularProgress className="icon_progress" />
                                            </td>
                                        </tr>
                                    );
                                } else {
                                    if (Object.entries(controllerDocumentList.getDataMainList).length === 0) {
                                        html.push(
                                            <tr className="empty_state">
                                                <td colSpan={100}>
                                                    <MuiFolderOpenIcon className="icon" />
                                                    <p>{controllerLocalization.getStorageMain.no_result}</p>
                                                </td>
                                            </tr>
                                        );
                                    } else {
                                        for (const [key, data] of Object.entries(controllerDocumentList.getDataMainList)) {
                                            const alternateRow = Number(key) % 2 === 1 ? "even" : "";

                                            html.push(
                                                <tr
                                                    className={`row ${alternateRow}`}
                                                    data-at_id={`tr_list_data_${data.id}`}
                                                    onClick={(event) => {
                                                        controllerDocumentList.clickItem(event, data);
                                                    }}
                                                >
                                                    <td className="cell">{data.id}</td>
                                                    <td className="cell">{data.project_name}</td>
                                                    <td data-at_id="td_client_name" className="cell">
                                                        {data.client_name}
                                                    </td>
                                                    <td className="cell">
                                                        {(() => {
                                                            return HelperSrc.showSelectedOptionName(
                                                                controllerDocumentList.getSelectOption.client_industry,
                                                                data.client_industry
                                                            );
                                                        })()}
                                                    </td>
                                                    <td className="cell">{data.filename}</td>
                                                    <td className="cell">{data.reporting_year}</td>
                                                    <td className="cell">{data.template_language}</td>
                                                    <td className="cell">
                                                        {data.latest_update ? HelperSrc.localeFormat(new Date(data.latest_update)) : ""}
                                                    </td>
                                                    <td className="cell">
                                                        {(() => {
                                                            for (const optionData of Object.values(
                                                                controllerDocumentList.getSelectOption.latest_update_by_id
                                                            )) {
                                                                const optionDataTyped = optionData as ModelHelperSrc.IelementOption;

                                                                if (data.latest_update_by_id === optionDataTyped.value) {
                                                                    return optionDataTyped.display_name;
                                                                }
                                                            }
                                                        })()}
                                                    </td>
                                                    <td className="cell center">
                                                        {(() => {
                                                            const html: JSX.Element[] = [];

                                                            if (
                                                                HelperSrc.checkRole(
                                                                    controllerDocumentList.getStorageRole,
                                                                    ["superuser", "manager"],
                                                                    props.userData
                                                                )
                                                            ) {
                                                                html.push(
                                                                    <MuiDeleteIcon
                                                                        data-at_id="icon_delete"
                                                                        className="button_icon"
                                                                        onClick={(event) => controllerDocumentList.clickRemove(event, data.id)}
                                                                    />
                                                                );
                                                            }

                                                            return html;
                                                        })()}
                                                    </td>
                                                </tr>
                                            );
                                        }
                                    }
                                }

                                return html;
                            })()}
                        </tbody>
                    </table>
                    <ViewPagination response={controllerDocumentList.getPagination} api={controllerDocumentList.apiDataList} />
                    <ViewDialog
                        className="document_remove_dialog"
                        isOpen={controllerDocumentList.getIsDialogOpen}
                        isApiLoading={controllerDocumentList.getApiLoadingList.removeData}
                        labelConfirm={controllerLocalization.getStorageMain.yes}
                        onClickConfirm={controllerDocumentList.clickDialogRemoveConfirm}
                        labelCancel={controllerLocalization.getStorageMain.no}
                        onClickCancel={controllerDocumentList.clickDialogRemoveCancel}
                        mode={"alert"}
                        content={controllerLocalization.getStorageMain.delete_record}
                    />
                    <ViewDialog
                        className="document_draft_remove_dialog"
                        isOpen={controllerDocumentList.getIsDraftDialogOpen}
                        isApiLoading={false}
                        labelConfirm={controllerLocalization.getStorageMain.yes}
                        onClickConfirm={controllerDocumentList.clickDialogDraftRemoveConfirm}
                        labelCancel={controllerLocalization.getStorageMain.no}
                        onClickCancel={controllerDocumentList.clickDialogDraftRemoveCancel}
                        mode={"alert"}
                        content={controllerLocalization.getStorageMain.delete_record}
                    />
                </div>
            </div>
        );
    } else {
        return <ViewLoader />;
    }
};

export default viewPageDocumentList;
